import Config from "@/mixins/map/Config";
import Popup from "@/mixins/map/Popup";
import Home from "@/mixins/map/Home";

export default {
  name: 'map',
  data() {
    return {
      activeLot: null,
      apartmentGeoJson: {
        type: 'FeatureCollection',
        features: [],
      },
      baseLayers: [],
      container: 'favorites-map',
      lotBounds: null,
      detailLayers: [],
      filteredlotGeoJson: {
        type: 'FeatureCollection',
        features: [],
      },
      layers: [],
      favoriteHnlList: null,
      lotgeo: require('@/assets/json/lotgeo.json'),
      lotGeoJson: null,
      lotPanelMarker: [],
      detailPanelMaker: null,
      masterBound: null,
      packageSummaryList: null,
      sources: [],
      svgConfig: null,
      stageGeoJson: {
        type: 'FeatureCollection',
        features: [],
      },
      viewBasedFilterLot: {
        type: 'FeatureCollection',
        features: [],
      }
    }
  },
  mixins: [Config, Popup],
  methods: {
    initMap: function (config, hnlsummary) {
      mapboxgl.accessToken = 'pk.eyJ1Ijoic2FpbGVzaGtjIiwiYSI6ImNrZGo1Y2l5dTBibGIzMXBmbzM5Z2Q3Z2MifQ.hq_fP_fYTmUm_LJNRl23Cw';
      if (
        config && hnlsummary
      ) {
        this.favoriteHnlList = hnlsummary;
        this.svgConfig = config;
        this.initConfig();
      }
    },

    addLotShapes: function () {
      const bounds = new mapboxgl.LngLatBounds();

      this.favoriteHnl.forEach(hnl => {
        const lotfeature = this.lotGeoJson.features.find(feature => feature.properties.lotCpId === hnl.lotproductcpid);
        const filteredfeature = this.filteredlotGeoJson.features.find(feature => feature.properties.lotCpId === hnl.lotproductcpid);

        if (filteredfeature) {
          return filteredfeature.properties.hnlproperties.push(hnl);
        }

        if (lotfeature) {
          lotfeature.properties.hnlproperties = [hnl];
          lotfeature.id = hnl.lotproductcpid;
          lotfeature.properties.hoverable = 'allow';
          lotfeature.properties.isActive = true;
          lotfeature.properties.interact = true;
          lotfeature.geometry.coordinates[0].forEach((cord) => {
            bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
          });

          this.filteredlotGeoJson.features.push(lotfeature);
        }
      })

      this.map.addSource('lots', {
        type: 'geojson',
        data: this.filteredlotGeoJson,
      });

      this.addLotFills();

      this.placeDetailLayer();
      this.addApartmentShapes();
      if (bounds && this.filteredlotGeoJson.features.length > 0) {
        this.lotBounds = bounds;
        this.map.fitBounds(bounds, {
          maxZoom: 19,
          padding: 60,
          pitch: 60
        });
      } else {
        this.map.fitBounds(this.masterBound, {
          pitch: 60
        });
      }
    },

    addLotFills: function () {
      this.map.addLayer({
        id: 'lot-fills',
        type: 'fill',
        source: 'lots',
        layout: {},
        paint: {
          'fill-color': '#688e9f',
          'fill-opacity': [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            0.4,
            0.9,
          ],
        },
      });

      this.map.on('mousemove', 'lot-fills', (e) => {
        if (e.features.length > 0) {
          if (e.features[0].properties.interact) {
            this.map.getCanvas().style.cursor = 'pointer';
            if (this.hoveredLotId) {
              this.map.setFeatureState(
                {source: 'lots', id: this.hoveredLotId},
                {hover: false}
              );
            }
            this.hoveredLotId = e.features[0].id;
            this.map.setFeatureState(
              {source: 'lots', id: this.hoveredLotId},
              {hover: true}
            );
          }
        }
      });

      this.map.on('mouseleave', 'lot-fills', () => {
        this.map.getCanvas().style.cursor = '';
        if (this.hoveredLotId) {
          this.map.setFeatureState(
            {source: 'lots', id: this.hoveredLotId},
            {hover: false}
          );
        }
        this.hoveredLotId = null;
      });

      this.map.on('click', 'lot-fills', (e) => {
        if (e.features.length > 0) {
          if (e.features[0].properties.interact) {
            const hnl = JSON.parse(e.features[0].properties.hnlproperties)[0]
            this.createPackageDetailMarker(hnl, e.features[0].geometry.coordinates[0]);
          }
        }
      });

      this.createLotMarker()
    },

    addHomesShapes: function () {

    },

    createLotMarker: function () {
      this.lotPanelMarker.forEach(m => {
        m.remove()
      })

      this.favoriteHnl.forEach(hnl => {
        const lotfeature = this.lotGeoJson.features.find(feature => feature.properties.lotCpId === hnl.lotproductcpid);
        if (lotfeature) {
          const markerBound = new mapboxgl.LngLatBounds();
          lotfeature.geometry.coordinates[0].forEach((cord) => {
            markerBound.extend(new mapboxgl.LngLat(cord[0], cord[1]));
          });

          const el = document.createElement('div');
          const img = document.createElement('img');
          el.className = 'facade-popup';
          img.src = hnl.imagepath;
          img.style.width = '100px'
          img.style.height = 'auto';
          el.appendChild(img);

          el.addEventListener('click', () => {
            this.createPackageDetailMarker(hnl, lotfeature.geometry.coordinates[0])
          })

          const m = new mapboxgl.Marker({
            element: el,
            anchor: 'bottom',
            offset: [0, -40]
          });
          m.setLngLat(markerBound.getCenter());
          this.lotPanelMarker.push(m);
          m.addTo(this.map);
        }
      })
    },

    resetTileView: function () {
      if (this.detailPanelMaker) {
        this.detailPanelMaker.remove();
      }

      this.lotPanelMarker.forEach(m => {
        m.addTo(this.map);
      })
    },

    createPackageDetailMarker: function (hnlSummary, coord) {
      if (this.detailPanelMaker) {
        this.detailPanelMaker.remove();
      }
      this.lotPanelMarker.forEach(m => {
        m.remove();
      })
      const markerBound = new mapboxgl.LngLatBounds();
      coord.forEach((cord) => {
        markerBound.extend(new mapboxgl.LngLat(cord[0], cord[1]));
      });
      if (this.detailPanelMaker) {
        this.detailPanelMaker.remove();
      }

      const el = this.getPackageTile(hnlSummary);

      const buttonsEl = document.createElement('div');
      buttonsEl.classList.add('explore-btns')

      const aEl = document.createElement('a');
      aEl.classList.add('modal-close');
      aEl.addEventListener('click', () => {
        this.resetTileView();
      })

      const aDetailEl = document.createElement('a');
      aDetailEl.classList.add('explore');
      aDetailEl.innerHTML = 'EXPLORE THIS HOME';

      buttonsEl.appendChild(aDetailEl);

      el.lastElementChild.appendChild(buttonsEl);
      el.appendChild(aEl);

      aDetailEl.addEventListener('click', () => {

        this.$router.push({
          path: '/community/package/' + hnlSummary.cpidstring
        })
        setTimeout(() => {
          if (this.detailPanelMaker) {
            this.detailPanelMaker.remove();
          }
        })
      })

      this.map.flyTo({
        center: markerBound.getCenter(),
        zoom: 18,
        essential: true
      });

      this.detailPanelMaker = new mapboxgl.Marker({
        element: el,
        anchor: 'bottom',
        offset: [0, -40]
      }).setLngLat(markerBound.getCenter());
      this.detailPanelMaker.addTo(this.map);
    },

    filterMapLots: function (hnllist) {
      this.specHomesList = hnllist;
      if (!this.map || !this.map.getSource('lots')) return;

      const bounds = new mapboxgl.LngLatBounds();

      this.filteredlotGeoJson.features.forEach(feature => {
        feature.properties.isActive = false;
        feature.properties.interact = false;
      });

      this.filteredlotGeoJson.features = [];

      hnllist.forEach(hnl => {
        const filteredfeature = this.filteredlotGeoJson.features.find(feature => feature.properties.lotCpId === hnl.lotproductcpid);

        if (filteredfeature) {
          return filteredfeature.properties.hnlproperties.push(hnl);
        }

        const lotfeature = this.lotgeo.geoJson.features.find(feature => feature.properties.lotCpId === hnl.lotproductcpid);

        if (lotfeature) {
          lotfeature.properties.hnlproperties = [hnl];
          lotfeature.id = hnl.lotproductcpid;
          lotfeature.properties.hoverable = 'allow';
          lotfeature.properties.isActive = true;
          lotfeature.properties.interact = true;
          lotfeature.geometry.coordinates[0].forEach((cord) => {
            bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
          });
          this.filteredlotGeoJson.features.push(lotfeature);
        }
      })

      this.map.getSource('lots').setData(this.filteredlotGeoJson);

      if (bounds && this.filteredlotGeoJson.features.length > 0 && hnllist.length) {
        this.lotBounds = bounds;
        this.map.fitBounds(bounds, {
          maxZoom: 19,
          padding: 60,
        });
      } else {
        this.map.fitBounds(this.masterBound);
      }
    },

    reset() {
      this.resetTileView();
      let bounds = this.masterBound;
      if (this.lotBounds) {
        bounds = this.lotBounds;
      }

      this.map.fitBounds(bounds, {
        maxZoom: 19,
      });

      this.removeDirection();
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/favorites/FavoriteMap.js